import { createSelector } from 'reselect';
import { getMachineSettings } from './getMachineSettings';
import { getIsJobLaborTrackingEnabled } from './getIsJobLaborTrackingEnabled';
import { getHasOpenActivitySetInSetup } from './getHasOpenActivitySetInSetup';

const getFAIEnabled = createSelector(
  [
    getMachineSettings,
    getIsJobLaborTrackingEnabled,
    getHasOpenActivitySetInSetup,
  ],
  (machineSettings, isLaborTicketFlowEnabled, hasOpenActivitySetInSetup) => {
    if (!isLaborTicketFlowEnabled || !hasOpenActivitySetInSetup) return false;
    return !!machineSettings?.firstArticleInspectionEnabled;
  }
);

export { getFAIEnabled };
